/**
 * Header translations
 * Navigation and header UI elements
 */

import { LANGUAGES } from '../config';

export const headerTranslations = {
  [LANGUAGES.EN]: {
    title: 'Esccot Competency Analyzer',
    languageSwitch: 'Switch to French',
    myProfile: 'My Profile',
    myDashboard: 'My Dashboard',
    adminDashboard: 'Admin Dashboard',
    teamManagement: 'Team Management',
    signOut: 'Sign Out'
  },
  [LANGUAGES.FR]: {
    title: 'Analyseur de Compétences Esccot',
    languageSwitch: 'Passer à l\'anglais',
    myProfile: 'Mon Profil',
    myDashboard: 'Mon Tableau de Bord',
    adminDashboard: 'Tableau de Bord Admin',
    teamManagement: 'Gestion d\'équipe',
    signOut: 'Déconnexion'
  }
};
